export default {"src":"/_next/static/media/utlra_sound_poap.d58edb6d.gif","height":1008,"width":1008};